"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaintNodes = void 0;
const react_1 = __importDefault(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const typestyle_1 = require("typestyle");
const vars_1 = require("../vars");
const index_1 = require("./Node/index");
const trees_1 = require("../state/containers/trees");
const index_2 = require("./Node/RootExtendNode/index");
const Main = typestyle_1.style({
    width: '100%',
    position: 'relative',
    fontFamily: vars_1.fontFamily,
    transition: `opacity 0.25s ease-in-out`,
});
exports.PaintNodes = () => {
    const { libraryTree, tree } = trees_1.useTreesState();
    const baseTypes = [
        graphql_zeus_1.TypeDefinition.ObjectTypeDefinition,
        graphql_zeus_1.TypeDefinition.InterfaceTypeDefinition,
        graphql_zeus_1.TypeDefinition.UnionTypeDefinition,
        graphql_zeus_1.TypeDefinition.EnumTypeDefinition,
        graphql_zeus_1.TypeDefinition.ScalarTypeDefinition,
        graphql_zeus_1.TypeDefinition.InputObjectTypeDefinition,
    ];
    return (react_1.default.createElement("div", { className: Main },
        baseTypes.map((d) => (react_1.default.createElement(index_1.RootNode, { key: d, node: {
                name: graphql_zeus_1.TypeDefinitionDisplayMap[d],
                data: {
                    type: d,
                },
                type: {
                    name: 'root',
                },
                args: tree.nodes.filter((n) => n.data.type === d).sort((a, b) => (a.name > b.name ? 1 : -1)),
            }, libraryNode: {
                name: graphql_zeus_1.TypeDefinitionDisplayMap[d],
                data: {
                    type: d,
                },
                type: {
                    name: 'root',
                },
                args: libraryTree.nodes.filter((n) => n.data.type === d).sort((a, b) => (a.name > b.name ? 1 : -1)),
            } }))),
        react_1.default.createElement(index_1.RootNode, { node: {
                name: graphql_zeus_1.TypeDefinitionDisplayMap.DirectiveDefinition,
                data: {
                    type: graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition,
                },
                type: {
                    name: 'root',
                },
                args: tree.nodes
                    .filter((n) => n.data.type === graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition)
                    .sort((a, b) => (a.name > b.name ? 1 : -1)),
            }, libraryNode: {
                name: graphql_zeus_1.TypeDefinitionDisplayMap.DirectiveDefinition,
                data: {
                    type: graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition,
                },
                type: {
                    name: 'root',
                },
                args: libraryTree.nodes
                    .filter((n) => n.data.type === graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition)
                    .sort((a, b) => (a.name > b.name ? 1 : -1)),
            } }),
        react_1.default.createElement(index_2.RootExtendNode, { node: {
                name: graphql_zeus_1.TypeSystemExtension.TypeExtension,
                data: {
                    type: graphql_zeus_1.TypeExtension.ObjectTypeExtension,
                },
                type: {
                    name: 'root',
                },
                args: tree.nodes
                    .filter((n) => n.data.type === graphql_zeus_1.TypeExtension.ObjectTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.InputObjectTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.EnumTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.ScalarTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.InterfaceTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.UnionTypeExtension)
                    .sort((a, b) => (a.name > b.name ? 1 : -1)),
            }, libraryNode: {
                name: graphql_zeus_1.TypeDefinitionDisplayMap.ObjectTypeExtension,
                data: {
                    type: graphql_zeus_1.TypeExtension.ObjectTypeExtension,
                },
                type: {
                    name: 'root',
                },
                args: libraryTree.nodes
                    .filter((n) => n.data.type === graphql_zeus_1.TypeExtension.ObjectTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.InputObjectTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.EnumTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.ScalarTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.InterfaceTypeExtension ||
                    n.data.type === graphql_zeus_1.TypeExtension.UnionTypeExtension)
                    .sort((a, b) => (a.name > b.name ? 1 : -1)),
            } })));
};
